var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { staticClass: "radio-container" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.radioButtonValue,
          expression: "radioButtonValue"
        }
      ],
      attrs: { type: "radio", name: _vm.name, disabled: _vm.disabled },
      domProps: {
        value: _vm.label,
        checked: _vm._q(_vm.radioButtonValue, _vm.label)
      },
      on: {
        change: [
          function($event) {
            _vm.radioButtonValue = _vm.label
          },
          _vm.input
        ]
      }
    }),
    _vm._v(" "),
    _c("span", { ref: "radio-button", staticClass: "radio-button" }),
    _vm._v(" "),
    _c("span", {
      staticClass: "radio-label",
      class: { "radio-label-no-margin": _vm.noLabelMargin },
      domProps: { innerHTML: _vm._s(_vm.label) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a78c594", { render: render, staticRenderFns: staticRenderFns })
  }
}